import { GraphComponent, IUndo, Properties } from "@/utils/lomakkeet.ts";
import { ReactElement } from "react";
import { ComponentType } from "@/graphHandling/components/componentType.ts";
import {
  has,
  includes,
  isEmpty,
  keys,
  map,
  mapObjIndexed,
  prop,
  values
} from "ramda";
import { ComponentEvent } from "@/graphHandling/graphTypes.ts";
import { IUndoProps, Undo } from "@/graphHandling/components/undo.tsx";

/**
 * Undo-komponentin määrittely.
 * @param properties
 * @param functions
 * @returns
 */
export function defineUndo(
  properties: IUndoProps,
  functions: { onClick: ComponentEvent }
): IUndo {
  return {
    name: ComponentType.UNDO,
    onClick: functions.onClick,
    properties
  };
}

/**
 * Undo-komponentin renderöintifunktio.
 * @param componentDefinition
 * @param listOfCellIds
 * @param readPath
 * @returns
 */
export function renderUndo(
  componentDefinition: IUndo,
  listOfCellIds: Array<string>,
  readPath: (pathToRead?: Array<number | string>) => unknown
): ReactElement | null {
  if (componentDefinition?.name === ComponentType.UNDO && readPath) {
    const { properties } = componentDefinition;

    const unsavedList = map(cellId => {
      const p = readPath(["components", cellId]) as Properties;
      return prop("isUnsaved", p);
    }, listOfCellIds).filter(Boolean);

    properties.isHidden = !includes(true, unsavedList);

    if (componentDefinition.onClick) {
      return (
        <Undo
          {...properties}
          listOfCellIds={listOfCellIds}
          onClick={componentDefinition.onClick}
        />
      );
    }
  }

  return null;
}

/**
 * Undo-komponentin renderöintifunktio 2.
 * @param componentDefinition
 * @param listOfCellIds
 * @returns
 */
export function renderUndo2(
  componentDefinition: IUndo,
  listOfCellIds: Array<string>
): ReactElement | null {
  if (componentDefinition?.name === ComponentType.UNDO) {
    const { properties } = componentDefinition;

    properties.isHidden = false;

    if (componentDefinition.onClick) {
      return (
        <Undo
          {...properties}
          listOfCellIds={listOfCellIds}
          onClick={componentDefinition.onClick}
        />
      );
    }
  }

  return null;
}

/**
 * Undo-komponentin renderöintifunktio 3.
 * @param componentDefinition
 * @param listOfComponents
 * @returns GraphComponent
 */
export function renderUndo3(
  componentDefinition: IUndo,
  listOfComponents: Record<string, GraphComponent>
): ReactElement | null {
  if (componentDefinition?.name === ComponentType.UNDO) {
    const { properties } = componentDefinition;

    properties.isHidden = !includes(
      true,
      values(
        mapObjIndexed(
          component =>
            has("modifications", component) &&
            !isEmpty(prop("modifications", component)),
          listOfComponents
        )
      )
    );

    if (componentDefinition.onClick) {
      return (
        <Undo
          {...properties}
          listOfCellIds={keys(listOfComponents)}
          onClick={componentDefinition.onClick}
        />
      );
    }
  }

  return null;
}
